export const userLogin = (data:any) => {
    const user= {
        email: (data.email.trim()).toLowerCase(),
        password: data.password.trim(),
    }

    return user;
}
